import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export const ConfirmLeaveResult = {
  Save: 'save',
  Discard: 'discard',
  Stay: 'stay'
} as const;
export type ConfirmLeaveResult = typeof ConfirmLeaveResult[keyof typeof ConfirmLeaveResult];

export interface ConfirmLeaveDialogData {
  showSave?: boolean;
}

@Component({
  standalone: false,
  selector: 'app-confirm-leave-dialog',
  templateUrl: './confirm-leave-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./confirm-leave-dialog.component.scss']
})
export class ConfirmLeaveDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmLeaveDialogComponent, ConfirmLeaveResult>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmLeaveDialogData
  ) { }

  onDiscard(): void {
    this.dialogRef.close(ConfirmLeaveResult.Discard);
  }

  onStay(): void {
    this.dialogRef.close(ConfirmLeaveResult.Stay);
  }

  onSave(): void {
    this.dialogRef.close(ConfirmLeaveResult.Save);
  }
}
